<template>
  <div class="setting-pagination-panel">
    <el-pagination
      class="is-background"
      :pager-count="getConfig.pagerCount"
      :background="getConfig.background"
      :page-sizes="getConfig.pageSizes"
      :page-size="getConfig.pageSize"
      :current-page="getConfig.currentPage"
      :layout="getConfig.layout"
      :total="getConfig.total"
      :hide-on-single-page="getConfig.hideSinglePage"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
export default {
  name: 'KrPagination',
  props: {
    paginationConfig: {
      type: Object,
      required: true,
    },
  },
  inject:["collapseTitles"],
  data() {
    return {
      pageSizes: [5, 10, 20, 30, 40, 50],
    };
  },
  computed: {
    getConfig() {
      let paginationConfig = {};
      if (!this.paginationConfig.pageSizes) {
        paginationConfig = { ...this.paginationConfig, pageSizes: this.pageSizes };
      } else {
        paginationConfig = this.paginationConfig;
      }
      return this.paginationConfig.total ? paginationConfig : {
        total: 0,
        pageSize: 10,
        currentPage: 1,
        layout: 'total, sizes, prev, pager, next, jumper',
        background: false,
        pageSizes: this.pageSizes,
        hideSinglePage: false,
      };
    },
  },
  methods: {
    handleSizeChange(size) {
      const {params: {moduleInfoId}} = this.$route;
      window.kr.sensors.track('aims_sizeChange_toggles', {
        moduleInfoName: moduleInfoId,
        tableName: this.collapseTitles,
        tableSize: size
      })
      this.$emit('handleSizeChange', size);
    },
    handleCurrentChange(val) {
      this.$emit('handleCurrentChange', val);
    },
  },
};
</script>

<style lang="scss">
  .setting-pagination-panel {
    padding-top: 16px;

    .el-pagination .el-select .el-input {
      width: 90px;
    }

    .el-pagination__sizes .el-input .el-input__inner {
      padding-left: 3px;
      border: 1px solid #BE8C4B;
      color: #BE8C4B;
    }

    .el-pager li,
    .el-pager li:last-child {
      font-family: "PingFangSC-Regular";
      font-size: 14px;
      color: $font-color-title;
      margin-left: 3px;
      margin-right: 3px;
      font-weight: 600;
      min-width: 28px;
    }

    .el-pager li.active {
      color: $color-primary;
      background-color: #f6f7fb;
    }
    .el-pagination {
  padding: 2px 5px 2px 0;

  > .btn-prev {
    margin-left: 0;
  }

  &.is-background {
    .el-pager {
      li {
        line-height: 26px;

        &.btn-quicknext,
        &.btn-quickprev {
          line-height: 26px;
        }
      }

      li:not(.disabled).active {
        background: #f2f8ff;
        color: $theme-color;
        border: 1px solid $theme-color;
        border-radius: 4px 4px 4px 4px;
        opacity: 1;
        color: #BE8C4B;
        border: 1px solid #BE8C4B;
      }
    }

    .el-select .el-input {
      margin: 0 6px 0 0;
    }
  }

  .el-icon-arrow-right {
    color: $icon-color;
  }
}

.el-pager li:hover,
.el-pagination.is-background .el-pager li:not(.disabled,.active,.btn-quicknext,.btn-quickprev):hover,
.el-pagination button:hover,
.el-pagination.is-background .el-pager li:not(.disabled,.active,.btn-quicknext,.btn-quickprev):hover,
.el-pagination button:hover {
  background: #f2f8ff;
  border: 1px solid #e4e5eb;
  color: $font-color-title;
}

.el-pager li:active,
.el-pagination.is-background .el-pager li:not(.disabled,.active):active,
.el-pagination button:active,
.el-pagination.is-background .el-pager li:not(.disabled,.active):active,
.el-pagination button:active {
  background: #dbeafa;
}

.el-pagination__sizes .el-input .el-input__inner:hover {
  border-color: #BE8C4B;
}

.el-pager li.active {
  color: #BE8C4B;
}

// 导致分页器第一页时偏移
// .el-pagination.is-background .btn-prev.disabled {
//   margin-left: 0;
// }

.el-pagination.is-background .btn-prev.disabled,
.el-pagination.is-background .btn-next.disabled,
.el-pagination.is-background .el-pager li.disabled {
  color: #c1c4cb;
  background: #fff;
  border: 1px solid #e4e5eb;
  border-radius: 4px;
  font-weight: 600;
}

.el-pagination.is-background button.btn-prev:not(.disabled,.active),
.el-pagination.is-background button.btn-next:not(.disabled,.active) {
  color: $font-color-exgrey;
}

.el-pagination.is-background button.btn-prev:not(.disabled,.active):hover,
.el-pagination.is-background button.btn-next:not(.disabled,.active):hover {
  background: $hover-bg-color;
}

.el-pagination.is-background .btn-prev,
.el-pagination.is-background .btn-next,
.el-pagination.is-background .el-pager li {
  background-color: #ffff;
  border: 1px solid #e4e5eb;
  border-radius: 4px;
  font-weight: 600;
  margin: 0 4px;
  color: $font-color-title;
}

.el-pagination.is-background .el-pager .el-icon-more {
  color: $icon-color;

  &:hover {
    color: $icon-color;
  }
}

.el-pagination__jump {
  margin-left: 11px;
  color: $font-color-title;
}

.el-pagination__editor {
  margin: 0 4px;
}

.el-pagination__editor.el-input .el-input__inner {
  border-radius: 4px;
  width: 40px;
  border: 1px solid #BE8C4B;
  color: #BE8C4B;
}

.el-pagination.is-background .el-pager li.btn-quicknext,
.el-pagination.is-background .el-pager li.btn-quickprev {
  &:hover {
    color: $font-color-exgrey;
    background: $hover-bg-color;
  }
}

.filter-el-popover {
  .el-pagination--small .btn-prev,
  .el-pagination--small .btn-next {
    color: $color-primary;
  }

  .el-pagination span:not([class*=suffix]),
  .el-pagination button {
    font-size: 14px;
  }
}
  }

</style>
